<template>
	<button
		type="button"
		class="button relative"
		:class="{ 'rounded-full': rounded }">
		<span
			v-if="$slots.icon"
			class="btn-icon"
			:class="{'mx-0': !$slots.default, invisible: loading}"
			aria-hidden="true"><slot name="icon" /></span>
		<span
			v-if="$slots.default"
			:class="{invisible: loading}"><slot /></span>
		<span
			v-if="$slots.icon_right"
			class="btn-icon btn-icon-right"
			:class="{'mx-0': !$slots.default, invisible: loading}"
			aria-hidden="true"><slot name="icon_right" /></span>
		<span
			v-if="loading"
			class="absolute inset-0 flex items-center justify-center">
			<!-- inherits the button's text color so the spinner stays visible on light variants -->
			<svg
				class="animate-spin h-5 w-5"
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24">
				<circle
					class="opacity-25"
					cx="12"
					cy="12"
					r="10"
					stroke="currentColor"
					stroke-width="4" />
				<path
					class="opacity-75"
					fill="currentColor"
					d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
			</svg>
		</span>
	</button>
</template>
<script setup lang="ts">
//eslint-disable-next-line
    const props = defineProps({ 
		loading: {
			type: Boolean,
			default: false
		},
		rounded: {
			type: Boolean,
			default: false
		} 
	})
</script>